import { useEffect, type JSX } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@invite/app-core';

export const LogoutScreen = (): JSX.Element => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    void (async () => {
      await signOut();
      await navigate('/login', { replace: true });
    })();
  }, [signOut, navigate]);
  return <div />;
};
